// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Batch } from './batch';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Reconciliation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  reconciliationId!: number;
  accountBalance!: number;
  accountId!: number;
  bankStatementBalance!: number;
  createdBy!: string;
  createdDate!: Date;
  flags?: number;
  isFinalised!: boolean;
  reconciliationDate!: Date;
  totalOutstandingPayments!: number;
  totalOutstandingReceipts!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId?: number;
  account!: Account;
  batches!: Batch[];
  user!: User;
}

